import React, { useState, useEffect, useContext } from 'react';
import './movement.css';
import { MovementContext } from '../../context/movementContext/MovementContext';
import { useParams, useNavigate } from 'react-router-dom';
import { getMovements } from '../../context/movementContext/apiCalls';
import PaginationComponent from '../../components/paginationComponent/PaginationComponent';
import TableComponent from '../../components/tableComponent/TableComponent';
import LoadingComponent from '../../components/loadingComponent/LoadingComponent';
import PageSizeComponent from '../../components/pageSizeComponent/PageSizeComponent';
import FilterDateInput from '../../components/filterDateInput/FilterDateInput';
import DropDownComponent from '../../components/dropDownComponent/DropDownComponent';
import ErrorComponent from '../../components/errorComponent/ErrorComponent';
import AdminSideBar from '../../components/adminSideBar/AdminSideBar';
import { typeActionsEnvois, typeMovements } from '../../data';
import { getAgencesByWilaya } from '../../context/agenceContext/apiCalls';
import { AgenceContext } from '../../context/agenceContext/AgenceContext';
import FilterInput from '../../components/filterInput/FilterInput';
import { AuthContext } from '../../context/authContext/AuthContext';

function Movement() {
    const { dispatch, movements, isFetching, error, count: pages, } = useContext(MovementContext);
    const { dispatch: dispatchAgence, agencesByWilaya } = useContext(AgenceContext);
    const { user } = useContext(AuthContext)

    const { page = 1 } = useParams();
    const navigate = useNavigate();
    const [pageSize, setPageSize] = useState(10);

    const [id, setId] = useState("");
    const [typeMovement, setTypeMovement] = useState({ nom: "Choisir Type", id: 0, });
    const [typeAction, setTypeAction] = useState({ nom: "Choisir Type", id: 0, });
    const [agence, setAgence] = useState({ nom: "Choisir Agence", id: 0, });
    const [dateMovement, setDateMovement] = useState("");

    useEffect(() => {
        getMovements(dispatch, pageSize, page, id, typeMovement.id, typeAction.id, agence.id, dateMovement);
    }, [dispatch, pageSize, page, id, typeMovement, typeAction, agence, dateMovement])

    useEffect(() => {
        navigate(`/movements/1`);
    }, [id, typeMovement, typeAction, agence, dateMovement])

    useEffect(() => {
        dispatch({
            type: "CLEAR_MOVEMENT",
        })
        getAgencesByWilaya(dispatchAgence);
    }, [])

    const getTypeAction = (statusCode) => {
        if (statusCode === 10) {
            return "preparation"
        } else if (statusCode === 1) {
            return "default"
        } else if (statusCode === 8) {
            return "reception-agence"
        } else if (statusCode === 2) {
            return "depot-agence"
        } else if (statusCode === 3) {
            return "acheminement-depart"
        } else if (statusCode === 4) {
            return "acheminement-arrive"
        } else if (statusCode === 5) {
            return "livraison-domicile"
        } else if (statusCode === 6) {
            return "livraison-agence"
        }
    }
    const getTypeMovement = (type) => {
        if (type === 1) {
            return "a-accuse"
        } else if (type === 2) {
            return "s-accuse"
        } else if (type === 3) {
            return "pick-up"
        } else if (type === 4) {
            return "autre"
        }
    }


    return (
        <div className='container-global'>
            <AdminSideBar activeTab="movement" />
            <div className='center'>
                <div className="title">
                    <span className="material-symbols-rounded">shoppingmode</span>
                    <span>Movements :</span>
                </div>

                {
                    error ? <ErrorComponent error={error} /> : (
                        <>
                            <div className="filter">
                                <span className="adv-research">Recherche Avancée</span>
                                <div className="filter-content">
                                    {/* <FilterInput placeholder={'ID'} setItem={setId} /> */}
                                    <DropDownComponent data={[{ nom: "Choisir Type", id: 0, }, ...typeMovements]} itemChoisir={typeMovement} setItemChoisir={setTypeMovement} filter />
                                    <DropDownComponent data={[{ nom: "Choisir Type", id: 0, }, ...(typeActionsEnvois.filter(item => item.id !== 1 && item.id !== 3 && item.id !== 4 && item.id !== 9))]} itemChoisir={typeAction} setItemChoisir={setTypeAction} filter />
                                    {
                                        (user.role === 1 || user.role === 2) && (
                                            <DropDownComponent data={[{ nom: "Choisir Agence", id: 0, }, ...agencesByWilaya]} itemChoisir={agence} setItemChoisir={setAgence} filter />
                                        )
                                    }

                                    <FilterDateInput placeholder={"Date"} item={dateMovement} setItem={setDateMovement} />
                                </div>
                            </div>

                            <div className="add-item">
                                <span className='color-2' onClick={() => navigate(`/movements/dechargeretourautre`)}>Ajouter Décharge Retour/Autre</span>
                                <span className='color-1' onClick={() => navigate(`/movements/decharge`)}>Ajouter Décharge Client</span>
                            </div>

                            {
                                isFetching ? <LoadingComponent /> : (
                                    movements.length === 0 ? <span className='no-data'>Il n'y a pas encore de données</span>
                                        : (
                                            <>
                                                <PageSizeComponent pageSize={pageSize} setPageSize={setPageSize} itemLocation='movements' />
                                                <div className="content">
                                                    {
                                                        <>
                                                            <TableComponent headers={['Type', 'Type Action', 'Agence', 'Montant', 'Date', 'Action']}>
                                                                {
                                                                    movements.map((movement, index) => (
                                                                        <tr key={index}>
                                                                            {/* <td>{movement.id}</td> */}
                                                                            <td>
                                                                                <span className={`table-special-border ${getTypeMovement(movement.type)}`}>{typeMovements.filter(item => item.id == movement.type)[0]['nom']}</span>
                                                                            </td>
                                                                            <td>
                                                                                <span className={`table-special ${getTypeAction(movement.typeAction)}`}>
                                                                                    {
                                                                                        movement.FactureId ? (
                                                                                            "Facturation"
                                                                                        ) : (
                                                                                            movement.typeAction === 1 ? ("Déchargement")
                                                                                                : (typeActionsEnvois.filter(item => item.id == movement.typeAction)[0]['nom'])
                                                                                        )
                                                                                    }
                                                                                </span>
                                                                            </td>
                                                                            <td>{movement.Agence ? movement.Agence.nom : ""} </td>
                                                                            <td>{Number.parseFloat(movement.montant).toFixed(2)}</td>
                                                                            <td>{movement.createdAt.slice(0, 10)}</td>
                                                                            <td>
                                                                                {
                                                                                    movement.FactureId ? (
                                                                                        <span className='update' onClick={() => navigate(`/invoices/${movement.FactureId}/detail/1`)}>Detail</span>
                                                                                    ) : (
                                                                                        movement.type === 2 ? (
                                                                                            <span className='update' onClick={() => navigate(`/movements/decharge/${movement.id}/detail/1`)}>Detail</span>
                                                                                        ) : (
                                                                                            movement.type === 3 ? (
                                                                                                <span className='update' onClick={() => navigate(`/movements/dechargeretourautre/${movement.id}/detail`)}>Detail</span>
                                                                                            ) : (
                                                                                                (movement.typeAction === 2 || movement.typeAction === 8 || movement.typeAction === 5 || movement.typeAction === 6) ? (
                                                                                                    <span className='update' onClick={() => navigate(`/movements/encaisse/${movement.id}/detail/1`)}>Detail</span>
                                                                                                ) : ""
                                                                                            )
                                                                                        )
                                                                                    )
                                                                                }
                                                                            </td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </TableComponent>
                                                            {
                                                                (pages > 1) && (<PaginationComponent page={page} pages={pages} item='movements' />)
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            </>
                                        )
                                )
                            }
                        </>
                    )
                }

            </div>

        </div>
    )
}

export default Movement
